import React from "react";
import FirstSpaMassage from "./components/spamassage/FirstSpaMassage";
import SecondSpaMassage from "./components/spamassage/SecondSpaMassage";
import ThirdSpaMassage from "./components/spamassage/ThirdSpaMassage";
import FourthSpaMassage from "./components/spamassage/FourSpaMassage";
import FifthSpaMassage from "./components/spamassage/FifthSpaMassage";

const SpaMassage = () => {
  return (
    <>
      <FirstSpaMassage />
      <SecondSpaMassage />
      <ThirdSpaMassage />
      <FourthSpaMassage />
      <FifthSpaMassage />
    </>
  );
};

export default SpaMassage;
